import { Helmet } from "react-helmet-async";
import { Layout } from "../../components/layout";
import {
  MyButton,
  CustomModal,
  Dropdown,
  Input,
  LoadingSpinner,
  Pagination,
  EmptyTable,
} from "../../components";
import { BsList, BsThreeDotsVertical } from "react-icons/bs";
import {
  IconButton,
  Menu,
  MenuItem,
  Button,
  Select,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FaFilter } from "react-icons/fa6";
import { StageController } from "../../controllers";
import { Cancel } from "../../../assets";
import { IoTrashOutline } from "react-icons/io5";
import { CiEdit } from "react-icons/ci";
import { IoAddSharp } from "react-icons/io5";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { FaAngleDown } from "react-icons/fa";
class Stage extends StageController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getStagesList();
  }
  render() {
    const {
      stagesList,
      loading,
      title,
      name,
      page,
      selectedItem,
      priority,
      estimate,
      count,
      rowsCountList,

      errorsList,
      openEditModal,
      openConfirmModal,
      openAddModal,
    } = this.state;
    return (
      <>
        <Layout title="مراحل">
          <Helmet>
            <title> مراحل | سامانه مشتریان</title>
          </Helmet>
          <div className="users-list">
            {loading ? (
              <LoadingSpinner />
            ) : (
              <>
                <>
                  <div className="users-list-headline mt-3">
                    <div className="">
                      <BsList color="#003366" className="ms-2" />{" "}
                      <span className="title">مراحل</span>
                    </div>
                    <div className="btn-group">
                      <MyButton
                        myStyle="add"
                        icon={<IoAddSharp className="ms-2" />}
                        title="افزودن"
                        onClick={() =>
                          this.setState({ openAddModal: !openAddModal })
                        }
                      />
                    </div>
                  </div>
                  <div className="users-list-container">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>ردیف</TableCell>
                          <TableCell>نام</TableCell>
                          <TableCell>عنوان</TableCell>
                          <TableCell>اولویت </TableCell>
                          <TableCell>درصد پیشرفت</TableCell>
                          <TableCell>عملیات</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {!stagesList?.list?.length && <EmptyTable />}
                        {stagesList?.list?.map((item: any, index: number) => {
                          return (
                            <>
                              <TableRow
                                key={index}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell component="th" scope="row">
                                  {index + 1}
                                </TableCell>
                                <TableCell>{item?.name || "--"}</TableCell>
                                <TableCell>{item?.title}</TableCell>
                                <TableCell>{item?.priority}</TableCell>
                                <TableCell>{item?.estimate_percent}</TableCell>

                                <TableCell>
                                  <PopupState
                                    variant="popover"
                                    popupId="demo-popup-menu"
                                  >
                                    {(popupState: any) => (
                                      <>
                                      <IconButton
                                                                                sx={{
                                                                                  color: "#0c1a58",
                                                                                  padding: "4px"
                                                                                }}
                                                                                {...bindTrigger(popupState)}
                                                                              >
                                                                                <BsThreeDotsVertical />
                                                                              </IconButton>
                                        {/* <Button
                                          sx={{
                                            background: "#D4AF37",
                                            ":hover": {
                                              bgcolor: "#D4AF37",
                                            },
                                          }}
                                          variant="contained"
                                          {...bindTrigger(popupState)}
                                        >
                                          عملیات
                                        </Button> */}
                                        <Menu {...bindMenu(popupState)}>
                                          <MenuItem
                                            onClick={() =>
                                              this.handleRemove(item)
                                            }
                                          >
                                            حذف
                                          </MenuItem>
                                          <MenuItem
                                            onClick={() =>
                                              this.handleUpdate(item)
                                            }
                                          >
                                            ویرایش
                                          </MenuItem>
                                        </Menu>
                                      </>
                                    )}
                                  </PopupState>
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })}
                      </TableBody>
                    </Table>
                    <Pagination
                      count={stagesList?.pages ? stagesList?.pages : 1}
                      page={page}
                      total={stagesList?.total}
                      pageNumber={stagesList?.page_number}
                      onChangePage={this.handleChangePage}
                      rowsCountList={rowsCountList}
                      countValue={count}
                      onChangeCount={(value: any) => this.handleCount(value)}
                    />
                  </div>
                </>
                <CustomModal
                  myStyle="fit-modal"
                  openModal={openAddModal}
                  onClose={() =>
                    this.setState({
                      openAddModal: !openAddModal,
                      estimate: "",
                      name: "",
                      priority: "",
                      title: "",
                    })
                  }
                >
                  <>
                    <div className="custom-modal-main-title mb-2">
                      <h1 className="custom-modal-title">افزودن مرحله</h1>
                      <Cancel
                        myStyle="ps-2 cursor-pointer"
                        color="#000000"
                        onClick={() =>
                          this.setState({
                            openAddModal: !openAddModal,
                            title: "",
                            name: "",
                            priority: "",
                            estimate: "",
                          })
                        }
                      />
                    </div>

                    <div className="custom-modal-content">
                    <div className="custom-modal-row">
                      <Input
                        myStyle=" w-100"
                        title="نام"
                        value={name}
                        onChange={(e: any) =>
                          this.setState({ name: e.target.value })
                        }
                        emptyState={() => this.setState({ name: "" })}
                        error={
                          errorsList.filter(
                            (name: { path: string }) => name.path === "name"
                          )?.[0]?.errors?.[0]
                        }
                      />
                    </div>
                    <div className="custom-modal-row">
                      <Input
                        myStyle=" w-100"
                        title="عنوان"
                        value={title}
                        onChange={(e: any) =>
                          this.setState({ title: e.target.value })
                        }
                        emptyState={() => this.setState({ title: "" })}
                        error={
                          errorsList.filter(
                            (name: { path: string }) => name.path === "title"
                          )?.[0]?.errors?.[0]
                        }
                      />
                    </div>
                    <div className="custom-modal-row">
                      <Input
                        type="number"
                        myStyle=" w-100"
                        title="الویت"
                        value={priority}
                        onChange={(e: any) =>
                          this.setState({ priority: e.target.value })
                        }
                        emptyState={() => this.setState({ priority: "" })}
                      />
                    </div>
                    <div className="custom-modal-row mb-57">
                      <Input
                        type="number"
                        myStyle=" w-100"
                        title="تخمین"
                        value={estimate}
                        onChange={(e: any) =>
                          this.setState({ estimate: e.target.value })
                        }
                        emptyState={() => this.setState({ estimate: "" })}
                        error={
                          errorsList.filter(
                            (name: { path: string }) => name.path === "estimate"
                          )?.[0]?.errors?.[0]
                        }
                      />
                    </div>
                    <div className="custom-modal-confirm ">
                      <MyButton
                        myStyle="bg-green"
                        title="اعمال"
                        loading={(this.state as any).isCreating}
                        onClick={() => this.handleNewStage()}
                      />
                    </div>
                  </div>
                  </>
                </CustomModal>
                <CustomModal
                  myStyle="fit-modal"
                  openModal={openEditModal}
                  onClose={() =>
                    this.setState({
                      openEditModal: !openEditModal,
                      title: "",
                      name: "",
                      priority: "",
                      estimate: "",
                      errorsList: [],
                    })
                  }
                >
                  <>
                    <div className="custom-modal-main-title mb-2">
                      <h1 className="custom-modal-title">ویرایش مرحله</h1>
                      <Cancel
                        myStyle="ps-2 cursor-pointer"
                        color="#000000"
                        onClick={() =>
                          this.setState({
                            openEditModal: !openEditModal,
                            title: "",
                            name: "",
                            priority: "",
                            estimate: "",
                            errorsList: [],
                          })
                        }
                      />
                    </div>

                    <div className="custom-modal-content">
                    <div className="custom-modal-row">
                      <Input
                        myStyle="w-100"
                        title="نام"
                        value={name}
                        onChange={(e: any) =>
                          this.setState({ name: e.target.value })
                        }
                        emptyState={() => this.setState({ name: "" })}
                        error={
                          errorsList.filter(
                            (name: { path: string }) => name.path === "name"
                          )?.[0]?.errors?.[0]
                        }
                      />
                    </div>
                    <div className="custom-modal-row">
                      <Input
                        myStyle=" w-100"
                        title="عنوان"
                        value={title}
                        onChange={(e: any) =>
                          this.setState({ title: e.target.value })
                        }
                        emptyState={() => this.setState({ title: "" })}
                        error={
                          errorsList.filter(
                            (name: { path: string }) => name.path === "title"
                          )?.[0]?.errors?.[0]
                        }
                      />
                    </div>
                    <div className="custom-modal-row">
                      <Input
                        type="number"
                        myStyle=" w-100"
                        title="الویت"
                        value={priority}
                        onChange={(e: any) =>
                          this.setState({ priority: e.target.value })
                        }
                        emptyState={() => this.setState({ priority: "" })}
                      />
                    </div>
                    <div className="custom-modal-row mb-57">
                      <Input
                        type="number"
                        myStyle=" w-100"
                        title="تخمین"
                        value={estimate}
                        onChange={(e: any) =>
                          this.setState({ estimate: e.target.value })
                        }
                        emptyState={() => this.setState({ estimate: "" })}
                        error={
                          errorsList.filter(
                            (name: { path: string }) => name.path === "estimate"
                          )?.[0]?.errors?.[0]
                        }
                      />
                    </div>
                    <div className="custom-modal-confirm">
                      <MyButton
                        myStyle="bg-green"
                        title="اعمال"
                        loading={(this.state as any).isUpdating}
                        onClick={() => this.sendUpdate()}
                      />
                    </div>
                  </div>
                  </>
                </CustomModal>
                <CustomModal
                  myStyle="delete-modal"
                  openModal={openConfirmModal}
                  onClose={() =>
                    this.setState({ openConfirmModal: !openConfirmModal })
                  }
                >
                  <>
                    <div className="custom-modal-main-title mb-2">
                      <h1 className="custom-modal-title">حذف</h1>
                      <Cancel
                        myStyle="ps-2 cursor-pointer"
                        color="#000000"
                        onClick={() =>
                          this.setState({ openConfirmModal: !openConfirmModal })
                        }
                      />
                    </div>
                    <div className="custom-modal-content">
                    <div className="custom-modal-row mb-37">
                      آیا از حذف مرحله با نام {selectedItem?.name} اطمینان
                      دارید؟
                    </div>
                    <div className="custom-modal-confirm">
                      <MyButton
                        myStyle="bg-green"
                        title="اعمال"
                        loading={(this.state as any).isDeleting}
                        onClick={() => this.confirmDelete()}
                      />
                      <MyButton
                        myStyle="bg-green"
                        title="انصراف"
                        onClick={() =>
                          this.setState({
                            selectedItem: null,
                            openConfirmModal: false,
                          })
                        }
                      />
                    </div>
                    </div>
                  </>
                </CustomModal>
              </>
            )}
          </div>
        </Layout>
      </>
    );
  }
}
export default Stage;
